import { render, staticRenderFns } from "./ProtoLeftSideTabs.vue?vue&type=template&id=52dc2718&scoped=true&"
import script from "./ProtoLeftSideTabs.vue?vue&type=script&lang=js&"
export * from "./ProtoLeftSideTabs.vue?vue&type=script&lang=js&"
import style0 from "./ProtoLeftSideTabs.vue?vue&type=style&index=0&id=52dc2718&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dc2718",
  null
  
)

export default component.exports